
import RsvpSmall from "./responseSmall"


function ResponseBpController({
    firstName, lastName, allowedAddtlGuest,
    inviteCode, inviteId }) {
    return (
        <RsvpSmall
            firstName={firstName}
            lastName={lastName}
            allowedAddtlGuest={allowedAddtlGuest}
            inviteCode={inviteCode}
            inviteId={inviteId}
        />
    )
}

export default ResponseBpController;

